<template>
  <div class="flex flex-col">
    <div class="font-bold">
      {{ addressTypeDisplay }}
    </div>
    <div v-if="addressData">
      <span class="ml-4"
        :class="{
          'text-sm': smallFont === true,
        }">
        {{ addressDisplay }}
      </span>
    </div>
    <div v-else>
      <span class="ml-4 text-gray-300">---</span>
    </div>
  </div>
</template>

<script>
import address from '../../../services/utils/address.js'

export default {
  props: {
    type: String,
    smallFont: Boolean,
    addressData: Object,
  },
  computed: {
    addressDisplay() {
      if (!this.addressData) return undefined

      return address.format(this.addressData)
    },
    addressTypeDisplay() {
      switch (this.type) {
        case 'pickup':
          return 'Pickup Address'
        case 'dropoff':
          return 'Dropoff Address'
        default:
          return 'Address'
      }
    },
  }
}
</script>
